const supportCtrl = true;
const supportAlt = true;
const supportShift = true;
const supportMeta = true;

const functionKeys = [
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'F11',
  'F12',
];

const specialKeys = [
  'Escape',
  'Delete',
  'Backspace',
  'Backquote',
  'Backslash',
  'Home',
  'PageUp',
  'PageDown',
  'End',
  'Tab',
];

const systemKeys = [
  'Control',
  'Shift',
  'Alt',
  'Meta'
]

export const detectHotkey = (e: KeyboardEvent): boolean => {
  if (e.ctrlKey && supportCtrl) {
    return true;
  }

  if (e.altKey && supportAlt) {
    return true;
  }

  if (e.shiftKey && supportShift) {
    return true;
  }

  if (e.metaKey && supportMeta) {
    return true;
  }

  return functionKeys.includes(e.code) || specialKeys.includes(e.code);
};

export const getHotkeyString = (e: KeyboardEvent): string => {
  const modifierKeys: string[] = [];

  if (e.ctrlKey) {
    modifierKeys.push('Ctrl');
  }

  if (e.altKey) {
    modifierKeys.push('Alt');
  }

  if (e.shiftKey) {
    modifierKeys.push('Shift');
  }

  if (e.metaKey) {
    modifierKeys.push('Meta');
  }

  if (systemKeys.includes(e.key)) {
    return `${modifierKeys.join(' + ')}`;
  }

  const mainKey = getKeyString(e.key);

  return modifierKeys.length > 0
    ? `${modifierKeys.join(' + ')} + ${mainKey}`
    : mainKey;
};

const getKeyString = (key: string): string => {
  // Special handling for Delete and Backspace keys
  if (key === 'Delete' || key === 'Backspace') {
    return 'Delete';
  }
  // Special handling for Command key on Mac
  if (key === 'Meta') {
    return 'Command';
  }
  // Use the key as is for other keys
  return key;
};
